import React from 'react';

const PhilosophySection = ({ data }) => {
    return (
        <section className="py-20 relative overflow-hidden">
            {/* Animated background elements */}
            <div className="absolute inset-0">
                <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl animate-blob"></div>
                <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl animate-blob animation-delay-2000"></div>
                <div className="absolute -bottom-8 left-1/2 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl animate-blob animation-delay-4000"></div>
            </div>

            <div className="container mx-auto px-4 relative">
                <div className="flex flex-col lg:flex-row items-center gap-16">
                    {/* Image Section with 3D effect */}
                    <div className="lg:w-1/2 relative group">
                        <div className="relative z-10 transform transition-all duration-700 group-hover:scale-105">
                            <div className="absolute -inset-4 bg-gradient-to-r from-yellow-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
                            <img 
                                src={data.imageSrc} 
                                alt="Our Philosophy" 
                                className="rounded-2xl shadow-2xl w-full relative z-10"
                            />
                        </div>
                        {/* Decorative elements */}
                        <div className="absolute -top-6 -left-6 w-24 h-24 border-2 border-yellow-500/30 rounded-lg transform rotate-12"></div>
                        <div className="absolute -bottom-6 -right-6 w-24 h-24 border-2 border-yellow-500/30 rounded-lg transform -rotate-12"></div>
                    </div>

                    {/* Content Section */}
                    <div className="lg:w-1/2">
                        <div className="relative">
                            {/* Title with decorative line */}
                            <div className="flex items-center gap-4 mb-8">
                                <div className="h-0.5 w-12 bg-yellow-500"></div>
                                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-yellow-600">
                                    {data.title}
                                </h2>
                            </div>

                            {/* Description with gradient text */}
                            <p className="text-gray-700 mb-8 leading-relaxed text-lg">
                                {data.description}
                            </p>

                            {/* Points with animated checkmarks */}
                            <div className="space-y-4">
                                {data.points.map((point, index) => (
                                    <div 
                                        key={point}
                                        className="group flex items-start gap-4 p-4 rounded-xl hover:bg-yellow-50/50 transition-all duration-300"
                                    >
                                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-yellow-500/10 flex items-center justify-center group-hover:bg-yellow-500/20 transition-colors duration-300">
                                            <span className="text-yellow-500 text-xl transform group-hover:scale-110 transition-transform duration-300">✓</span>
                                        </div>
                                        <p className="text-gray-700 group-hover:text-gray-900 transition-colors duration-300">
                                            {point}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PhilosophySection; 